"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var upload_file_1 = __importDefault(require("./upload_file"));
var util_1 = require("./util");
var initUploadFields = function (form, options) {
    if (options === void 0) { options = {}; }
    var matchesPrefix = function (fieldName) {
        if (!(options && options.prefix)) {
            return true;
        }
        return fieldName.startsWith("".concat(options.prefix, "-"));
    };
    var getPrefix = function () {
        return options && options.prefix ? options.prefix : null;
    };
    var getInputValue = function (fieldName) {
        return (0, util_1.getInputValueForFormAndPrefix)(form, fieldName, getPrefix());
    };
    var getInitialFiles = function (element) {
        var filesData = element.dataset.files;
        if (!filesData) {
            return [];
        }
        return JSON.parse(filesData);
    };
    var getPlaceholders = function (fieldName) {
        var data = getInputValue((0, util_1.getPlaceholderFieldName)(fieldName, getPrefix()));
        if (!data) {
            return [];
        }
        return JSON.parse(data);
    };
    var getS3Uploads = function (fieldName) {
        var data = getInputValue((0, util_1.getS3UploadedFieldName)(fieldName, getPrefix()));
        if (!data) {
            return [];
        }
        return JSON.parse(data);
    };
    var uploadUrl = getInputValue("upload_url");
    var formId = getInputValue("form_id");
    var s3UploadDir = getInputValue("s3_upload_dir");
    var skipRequired = options.skipRequired || false;
    var prefix = getPrefix();
    if (!formId || !uploadUrl) {
        return;
    }
    form.querySelectorAll(".dff-uploader").forEach(function (uploaderDiv) {
        var container = uploaderDiv.querySelector(".dff-container");
        if (!container) {
            return;
        }
        var input = container.querySelector("input[type=file]");
        if (!(input && matchesPrefix(input.name))) {
            return;
        }
        var fieldName = input.name;
        var multiple = input.multiple;
        var initial = getInitialFiles(container)
            .concat(getPlaceholders(fieldName))
            .concat(getS3Uploads(fieldName));
        var dataTranslations = container.getAttribute("data-translations");
        var translations = dataTranslations
            ? JSON.parse(dataTranslations)
            : {};
        var supportDropArea = !(options.supportDropArea === false);
        new upload_file_1.default({
            callbacks: options.callbacks || {},
            chunkSize: options.chunkSize || 2621440,
            eventEmitter: options.eventEmitter,
            fieldName: fieldName,
            form: form,
            formId: formId,
            s3UploadDir: s3UploadDir || null,
            initial: initial,
            input: input,
            multiple: multiple,
            parent: container,
            prefix: prefix,
            retryDelays: options.retryDelays || null,
            skipRequired: skipRequired,
            supportDropArea: supportDropArea,
            translations: translations,
            uploadUrl: uploadUrl
        });
    });
};
var initFormSet = function (form, optionsParam) {
    var options;
    if (typeof optionsParam === "string") {
        options = { prefix: optionsParam };
    }
    else {
        options = optionsParam;
    }
    var prefix = options.prefix || "form";
    var totalFormsValue = (0, util_1.getInputValueForFormAndPrefix)(form, "TOTAL_FORMS", prefix);
    if (!totalFormsValue) {
        return;
    }
    var formCount = parseInt(totalFormsValue, 10);
    for (var i = 0; i < formCount; i += 1) {
        var subFormPrefix = (0, util_1.getInputNameWithPrefix)("".concat(i), null);
        initUploadFields(form, __assign(__assign({}, options), { prefix: "".concat(prefix, "-").concat(subFormPrefix) }));
    }
};
global.initFormSet = initFormSet;
global.initUploadFields = initUploadFields;
document.addEventListener("DOMContentLoaded", function () {
    var uploadForm = document.getElementById("upload-file-form");
    if (uploadForm !== null) {
        initUploadFields(uploadForm);
    }
});
